import React from 'react'
import { useSelector } from 'react-redux'
import i18n from 'i18n-js'

import './DamageResult.scss'

const DamageResult = props => {
    console.log('DamageResult', props)
    const buildings = useSelector(state => state.buildings)

    const arenaATKBuilding = buildings.find(el => el.id === 'ancient_sword') // ancient_sword
    const arenaATK = arenaATKBuilding.options.find(el => el.value === arenaATKBuilding.value).atk
    const arenaFireATKBuilding = buildings.find(el => el.id === 'fire_sanctuary') // fire_sanctuary
    const arenaFireATK = arenaFireATKBuilding.options.find(el => el.value === arenaFireATKBuilding.value).atk
    const arenaCDMGBuilding = buildings.find(el => el.id === 'fallen_ancient_guardian') // fallen_ancient_guardian
    const arenaCDMG = arenaCDMGBuilding.options.find(el => el.value === arenaCDMGBuilding.value).cdmg
    const arenaDEFBuilding = buildings.find(el => el.id === 'guardstone') // guardstone
    const arenaDEF = arenaDEFBuilding.options.find(el => el.value === arenaDEFBuilding.value).def
    const arenaHPBuilding = buildings.find(el => el.id === 'crystal_altar') // crystal_altar
    const arenaHP = arenaHPBuilding.options.find(el => el.value === arenaHPBuilding.value).hp
    const arenaSPDBuilding = buildings.find(el => el.id === 'sky_tribe_totem') // sky_tribe_totem
    const arenaSPD = arenaSPDBuilding.options.find(el => el.value === arenaSPDBuilding.value).spd
    const guildLevel = buildings.find(el => el.id === 'guild_level')
    const { atk: guildATK, hp: guildHP, def: guildDEF } = guildLevel.options.find(el => el.value === guildLevel.value)

    // total atk
    // base atk * (1+((fightset * 8)+ atk leader skill + ancient sword + fire sanctuary + guild attack)/100)+runes attack
    const totalATK = props.baseATK * (1 + ((props.fightSets * 8) + props.atkLeader + arenaATK + arenaFireATK + guildATK) / 100) + props.runesATK

    // atk buff effect
    // 1.5+(artifact_attack_buff/100)*0.5
    const attBuff = 1.5 + (props.atk_effect / 100) * 0.5

    // ARTIFACTS
    const buffedAttack = totalATK * attBuff
    const atkArtifact = attBuff * buffedAttack * (props.dmg_percentage_atk / 100)
    const totalDef = props.baseDEF * (1 + (arenaDEF + guildDEF) / 100) + props.runesDEF
    const defArtifact = totalDef * (props.dmg_percentage_def / 100)
    const totalHP = props.baseHP * (1 + (arenaHP + guildHP) / 100) + props.runesHP
    const hpArtifact = totalHP * (props.dmg_percentage_hp / 100)
    const totalSpd = props.baseSPD * (1 + arenaSPD / 100) + props.runesSPD
    const spdArtifact = totalSpd * (props.dmg_percentage_spd / 100)

    // (total atk * atk buff effect) * 4 * (1 + (total cdmg + artifact s3 cdmg + cdmg tower + s3 skill ups)/100) * (1000 / (1140+3.5*801))*1.4+ artifacts damage (spd, atk, def, hp)
    const formula = (((totalATK * attBuff) * 4 * (1 + (props.cdmg + props.s3_damage + arenaCDMG + props.skillUp) / 100)) * (1000 / (1140 + 3.5 * 801))) * 1.4 + atkArtifact + defArtifact + hpArtifact + spdArtifact

    return <div className="DamageResult">
        {i18n.t('damage')}: {parseInt(formula)}
    </div>
}

export default DamageResult